import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ConsultationCard from "./ConsultationCard";
import MoreModal from "../../../globalComponents/MoreModal/MoreModal";
import ConfirmModal from "../../../globalComponents/ConfirmModal/ConfirmModal";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";
import moment from "moment";
import { styled } from "@mui/material";

const ConsultationData = ({ getNextConsultation, userData }) => {
  const { hasMore, consultationData } = useSelector(
    (state) => state.consultationPagination,
  );
  const [openMoreModal, setOpenMoreModal] = useState(false);
  const { openConfirmModal } = useSelector((state) => state.consultationModal);
  const [scrollHeight, setScrollHeight] = useState(1);

  // console.log(consultationData)
  const tableHead = [
    "Tələbə",
    "Mobil nömrə",
    "Təkrar müraciət",
    "Leadin yarandığı tarix",
    "Leadin yarandığı saat",
    "Əməkdaş",
    "5 də 5 toxunuş",
    "Statusa əlavə qeyd",
    "Lead haradan gəlib",
    "İxtisas",
    "Kursa qoşulma məqsədi",
    "Hazırkı məşğuliyyət",
    "Ödəniş planı",
    "Satış növü",
    "Fin kod",
    "Seriya nömrəsi",
    "Doğum tarixi",
    "Ödəniş formatı",
    "Email",
    "Qrup",
    "İmzalanmış Müqavilə",
    "Məlumatların təsdiqi",
    "",
  ];
  

  useEffect(() => {
    if (openMoreModal) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "overlay";
    }
  }, [openMoreModal]);

  useEffect(() => {
    const mainHeader = document.querySelector(".main-header");
    const detailsHeader = document.querySelector(".details-header");

    const handleResize = () => {
      setScrollHeight(
        window.innerHeight -
          mainHeader.offsetHeight -
          detailsHeader.offsetHeight,
      );
    };

    setScrollHeight(
      window.innerHeight - mainHeader.offsetHeight - detailsHeader.offsetHeight,
    );

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <>
        {openMoreModal && (
          <MoreModal
            userData={userData}
            setOpenMoreModal={setOpenMoreModal}
            type="consultation"
          />
        )}

        {openConfirmModal && <ConfirmModal type="consultation" />}

        <div className="table-con">
          <InfiniteScroll
            style={{ overflowX: "none" }}
            dataLength={consultationData.length}
            next={getNextConsultation}
            hasMore={hasMore}
            loader={<SmallLoading />}
            endMessage={
              <p style={{ textAlign: "center", fontSize: "20px" }}></p>
            }
            height={scrollHeight}
            scrollThreshold={0.7}
          >
            <table className="details-table consultation-page ">
              <thead>
                <tr>
                  {tableHead.map((head, i) => (
                    <th
                      className={`table-head-w ${
                        head === "Tələbə" ||
                        head === "Əməkdaş" ||
                        head === "Təlimçi"
                          ? "consultation-teacher-w"
                          : head === "Mobil nömrə"
                            ? "career-phone-w"
                            : head === "İxtisas" || head === "Qrup"
                              ? "career-group-name-w"
                              : head === "Sahə biliyi"
                                ? "level-w"
                                : head === "Əlaqə tarixi" ||
                                    head === "Konsultasiya tarixi" ||
                                    head === "Satış tarixi" ||
                                    "Doğum tarixi"
                                  ? "date-w"
                                  : head === "Konsultasiya saatı"
                                    ? "consultation-time-w"
                                    : head === "Ləğv səbəbi"
                                      ? "cancel-reason-w"
                                      : ""
                      }`}
                      key={i}
                      style={{
                        textAlign: "start",
                        minWidth:
                          head === "Məlumatların təsdiqi"
                            ? "180px"
                            : head === "5 də 5 toxunuş"
                              ? "200px"
                              : head === "Fin kod"
                                ? "100px"
                                : head === "İmzalanmış Müqavilə"
                                  ? "260px"
                                  : head === ""
                                    ? "50px"
                                    : "",
                      }}
                    >
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {consultationData?.map((consultation, i) => {
                  const currContactDate = new Date(consultation.contactDate);
                  const beforeContactDate =
                    i > 0 && new Date(consultationData[i - 1].contactDate);

                  return (
                    <React.Fragment key={consultation._id}>
                      {i > 0 &&
                        currContactDate.getDate() !==
                          beforeContactDate.getDate() && (
                          <tr>
                            <td
                              colSpan={tableHead.length}
                              style={{ height: "25px", padding: 0, zIndex: 2 }}
                            >
                              <div
                                style={{
                                  height: "100%",
                                  background: "var(--tertiary-200)",
                                  display: "flex",
                                  justifyContent: "start",
                                  paddingLeft: "25px",
                                  boxSizing: "border-box",
                                }}
                              >
                                <span>
                                  {consultation?.contactDate
                                    ? moment(consultation?.contactDate)
                                        .locale("az")
                                        .format("DD MMMM YYYY")
                                    : ""}
                                </span>
                              </div>
                            </td>
                          </tr>
                        )}
                      <ConsultationCard
                        data={consultation}
                        mode="desktop"
                        consultation={userData}
                        setOpenMoreModal={setOpenMoreModal}
                        cellNumber={i + 1}
                      />
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>

        {/* <div className="details-list-tablet with-more">
            {consultationData?.map((student, i) => (
              <ConsultationCard
                key={i}
                data={student}
                mode="tablet"
                setOpenMoreModal={setOpenMoreModal}
                cellNumber={i + 1}
                consultation={userData}
              />
            ))}
          </div> */}
      </>
    </>
  );
};

export default ConsultationData;
